var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_c('span',{class:'scolor leilao-status leilao-status-interno-' + _vm.status},[_vm._v(_vm._s(_vm.getStatus(_vm.status).title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }